export const USER_RESULTS_LIMIT = 30;
